import React from 'react';
import './index.css';
import TextToSpeech from './txtTospeech.js';

export default function PreWork() {
  return (
    <div className="sectionComponent">
      <h1>Pre-CS Work</h1>
      <TextToSpeech
        inputText={
          'USC Neuroimaging and Informatics Institute. Research Assistant. Conducted Neuroscience research focused on white-matter microstructure in brains of patients with Autism Spectrum Disorder. USC Dickman Lab. Laboratory Manager. Conducted neuroscience research focused on fruit fly neuromuscular junction. Managed a lab of over 20 people, running inspections, tracking inventory, budgeting, and expenses. '
        }
      ></TextToSpeech>
      <dl>
      <dt>USC Neuroimaging and Informatics Institute</dt>
        <dd>Research Assistant</dd>
        <dd>Developed innovative solutions for data processing across several programming languages. Performed programmatic statistical analysis, data planning and processing on 16 datasets. Skills used: Python, Bash, R, FreeSurfer, FMRIB Software Library</dd>
        <dt>USC Dickman Lab</dt>
        <dd>Laboratory Manager</dd>
        <dd>
          Conducted neuroscience research focused on fruit fly neuromuscular
          junction. 
        </dd>
        <dd>
          Managed a lab of over 20 people, running inspections, tracking
          inventory, budgeting, and expenses.
        </dd>
      </dl>
    </div>
  );
}
